<template>
<div>
    <div class="flip-container" @click="flipped = !flipped" v-bind:class="{flipped: flipped}">
        <div class="flipper">
            <div class="front">
                <h1>Cool Content Behind Here</h1>
            </div>
            <div class="back">
                <div class="title">
                    <h1>WoW!</h1>    
                </div>
                <div class="info">
                    <div class="list">
                        <h4 class="list__title">Here's Stuff</h4>
                        <ul>
                            <li>Stuff</li>
                            <li>Stuff</li>
                            <li>Stuff</li>
                        </ul>
                    </div>
                    <div class="list">
                        <h4 class="list__title">Other Stuff</h4>
                        <ul>
                            <li>Stuff</li>
                            <li>Stuff</li>
                            <li>Stuff</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

</template>

<script>
export default {
    name: 'Flipper',    
    data: function() {
        return {
            flipped: false
        }
    }
}
</script>


<style>
    /* entire container, keeps perspective */
.flip-container {
	perspective: 1000px;
    margin: 0 auto;
    border-radius: 3rem;
}

.flip-container:hover {
    background: rgba(224, 195, 195, 0.25);
}

.flip-container.flipped .flipper {
    transform: rotateX(180deg);
}

.flip-container {
	width: 50%;
	height: 20rem;
}

/* flip speed goes here */
.flipper {
	transition: 0.6s;
	transform-style: preserve-3d;
    width: 100%;
    height: 100%;
	position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
}

/* hide back of pane during swap */
.front, .back {
    /* width: 100%; */
    /* height: 100%; */
	backface-visibility: hidden;
	position: absolute;
    /* width: inherit;
    height: inherit; */
	/* top: 0;
	left: 0; */
}

/* front pane, placed above back */
.front {
	z-index: 2;
	/* for firefox 31 */
	transform: rotateX(0deg);
}

/* back, initially hidden pane */
.back {
	transform: rotateX(180deg);
}

.back {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 50%;
}
.back .info {
    width: 100%;
    display: flex;
    justify-content: space-around;
}

@media (max-width: 960px) {
    .flip-container {
        text-align: center;
        width: 90%;
    }

    .back {
        width: 100%;
    }
}
</style>
